<template>
<b-modal id="create-links-modal" title="Create links" okTitle="Create" @show="reset" @ok.prevent="createLinks">
  <div class="row">
    <div class="col-2">
      <label for="creationMode">Mode:</label>
    </div>
    <div class="col-10">
      <b-form-group v-slot="{ creationMode }" id="creationMode">
        <b-form-radio-group id="creation-mode-group" v-model="mode" :aria-describedby="creationMode" name="creation-mode">
          <b-form-radio value="single">single</b-form-radio>
          <b-form-radio value="multiple">multiple (upload list)</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </div>
  </div>
  <b-form inline v-if="mode === 'single'">
    <label class="w-25" for="url-input">URL</label>
    <b-form-input v-model.trim="url" id="url-input" class="w-75" aria-describedby="url-input-feedback" :state="urlState" v-on:input="resetErrors">
    </b-form-input>
    <b-form-invalid-feedback id="url-input-feedback" class="text-right">{{urlError}}</b-form-invalid-feedback>
    <label class="w-25 mt-2" for="node-name-input">Node name</label>
    <b-form-input v-model.trim="nodeName" id="node-name-input" class="w-75 mt-2" aria-describedby="node-name-input-feedback" :state="nodeNameState" v-on:input="resetErrors">
    </b-form-input>
    <b-form-invalid-feedback id="node-name-input-feedback" class="text-right">{{nodeNameError}}</b-form-invalid-feedback>
  </b-form>
  <b-form inline v-if="mode === 'multiple'">
    <p>
      Upload list of links (separated by newlines)<br />
      <em>Maximum 1000 links per file!</em>
    </p>
    <b-form-file class="text-left" v-model="file" :multiple="false" placeholder="Choose your file or drop it here..." drop-placeholder="Drop file here..." :state="fileState"></b-form-file>
    <b-form-invalid-feedback id="file-input-feedback" class="text-right">{{fileError}}</b-form-invalid-feedback>
  </b-form>
</b-modal>
</template>

<script>
import client from 'api-client'

export default {
  data() {
    return {
      mode: 'single',
      url: null,
      nodeName: null,
      urlError: null,
      nodeNameError: null,
      file: null,
      fileError: null
    };
  },
  computed: {
    urlState() {
      if (this.urlError) {
        return false;
      }
      return null;
    },
    nodeNameState() {
      if (this.nodeNameError) {
        return false;
      }
      return null;
    },
    fileState() {
      if (this.fileError) {
        return false;
      }
      return null;
    }
  },
  methods: {
    reset() {
      this.mode = 'single';
      this.url = null;
      this.nodeName = null;
      this.file = null;
      this.resetErrors();
    },
    resetErrors() {
      this.urlError = null;
      this.nodeNameError = null;
      this.fileError = null;
    },
    createLinks() {
      let path = this.$store.state.path;

      if (this.mode === 'single') {
        if (!this.url) {
          this.urlError = "URL is required";
          return;
        }
        try {
          new URL(this.url);
        } catch (_) {
          this.urlError = "Invalid URL";
          return;
        }

        if (!this.nodeName) {
          this.nodeNameError = "Node name is required";
          return;
        } else if (/[<>?":\\/`|'*]/.test(this.nodeName)) {
          this.nodeNameError = "Node name contains an illegal character. Following characters are not allowed: < > ? \" : \\ / | ' * `";
          return;
        }

        client.createLink(this.url, path, this.nodeName).then(() => {
          this.$bvModal.hide('create-links-modal');
          // Reload current node
          this.$store.dispatch('setPath', path);
        });

      } else {
        if (!this.file) {
          this.fileError = "File is required";
          return;
        }

        client.uploadLinks(this.file, path).then(() => {
          this.$bvModal.hide('create-links-modal');
          // Reload current node
          this.$store.dispatch('setPath', path);
        });
      }
    }
  }
}
</script>
